export const screenStyles = {
    width: '100vw',
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: 'rgb(238, 238, 238)',
    position: 'absolute',
    zIndex: '100',
    top: '0',
    left: '0',
    justifyContent: 'center',
    alignItems: 'center'
}

export const headerLoadingStyles = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 20,
    backgroundColor: 'black',
    boxShadow: 'none',
    flexDirection: 'column',
    opacity: '0.9',
    width: '100%',
    maxHeight: '100%',
    padding: 40
}

export const canvasStyle = {
    position: 'absolute',
    top: '0',
    bottom: '0',
    left: '0',
    right: '0',
    zIndex: '-1'
}